import api from './api';

export type EstadoJustificacion = 'PENDIENTE' | 'APROBADA' | 'RECHAZADA';

export interface JustificacionTipo {
  _id: string;
  nombre: string;
  duracionHoras: number;
  activo: boolean;
}

export interface CreateJustificacionTipoPayload {
  nombre: string;
  duracionHoras: number;
  activo?: boolean;
}

export interface AsignacionJustificacionPayload {
  tipoJustificacionId: string;
  agenteIds: string[];
  fecha: string;
  fechaHasta?: string;
  detalle?: string;
  estado?: EstadoJustificacion;
}

export const getTiposJustificacion = () => api.get<JustificacionTipo[]>('/justificaciones/tipos');

export const createTipoJustificacion = (payload: CreateJustificacionTipoPayload) =>
  api.post<JustificacionTipo>('/justificaciones/tipos', payload);

export const updateTipoJustificacion = (id: string, payload: Partial<CreateJustificacionTipoPayload>) =>
  api.patch<JustificacionTipo>(`/justificaciones/tipos/${id}`, payload);

export const removeTipoJustificacion = (id: string) => api.delete(`/justificaciones/tipos/${id}`);

export const asignarJustificacionMasiva = (payload: AsignacionJustificacionPayload) =>
  api.post<{ creadas: number; omitidas: number }>('/justificaciones/asignacion-masiva', payload);
